// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__28z3T","range":"MonthRangeSwitch_range__2dE6m","disabled":"MonthRangeSwitch_disabled__1iOnw"};